import { render, staticRenderFns } from "./ContractMessagesCustomization.vue?vue&type=template&id=5f5de7ac&"
import script from "./ContractMessagesCustomization.vue?vue&type=script&lang=js&"
export * from "./ContractMessagesCustomization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports